import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title flex-column justify-content-center" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "fs-7 text-gray-400" }
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_10 = { class: "me-3" }
const _hoisted_11 = { class: "me-3" }
const _hoisted_12 = {
  type: "button",
  class: "btn btn-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2" }
const _hoisted_14 = {
  type: "button",
  class: "btn btn-primary ms-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_add_stock_in"
}
const _hoisted_15 = { class: "svg-icon svg-icon-2" }
const _hoisted_16 = { class: "ms-3" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_19 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_20 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-250px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_21 = { class: "menu-item px-3" }
const _hoisted_22 = { class: "menu-content fs-6 text-dark fw-bolder px-3 py-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_24 = { class: "menu-item px-3" }
const _hoisted_25 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_26 = { class: "card-body pt-0 vip-table" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "text-warning"
}
const _hoisted_29 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_30 = { class: "fs-7 text-gray-400" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "fs-7 text-gray-400 text-nowrap" }
const _hoisted_34 = { class: "d-flex justify-content-end gap-3" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_FilterDropdown = _resolveComponent("FilterDropdown")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_MBDatatablePlus = _resolveComponent("MBDatatablePlus")!
  const _component_update_inventory = _resolveComponent("update-inventory")!
  const _component_add_stock_in = _resolveComponent("add-stock-in")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
              class: "form-control form-control-solid w-250px ps-14",
              placeholder: _ctx.t('common.search')
            }, null, 40, _hoisted_6), [
              [_vModelText, _ctx.search]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle",
              style: {"cursor":"pointer"},
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
            }, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ], 512), [
              [_vShow, _ctx.search != '']
            ])
          ]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t("warehouseInventory.availableAndSkus", [
            _ctx.options.available_total,
            _ctx.options.available_sku,
          ])), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_select, {
                disabled: _ctx.loading,
                modelValue: _ctx.options.warehouseInventoryType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.options.warehouseInventoryType) = $event)),
                onChange: _ctx.filterChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouseInventory, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_select, {
                disabled: _ctx.loading,
                modelValue: _ctx.options.warehouse_id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.options.warehouse_id) = $event)),
                onChange: _ctx.filterChange
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.warehouse, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue", "onChange"])
            ]),
            _createElementVNode("button", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen031.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.filter")), 1)
            ]),
            _createVNode(_component_FilterDropdown, {
              option: _ctx.options,
              warehouseInventoryType: _ctx.options.warehouseInventoryType,
              onSubmitFilter: _ctx.handleFilter,
              onResetFilter: _ctx.handleFilterReset
            }, null, 8, ["option", "warehouseInventoryType", "onSubmitFilter", "onResetFilter"]),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.add")) + _toDisplayString(_ctx.t("common.preStock")), 1)
            ])), [
              [_directive_auth, { auth: ['add'] }]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "btn btn-icon btn-bg-light btn-active-color-primary",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end",
                disabled: _ctx.loading || _ctx.disabledExport
              }, [
                (_ctx.disabledExport)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18))
                  : (_openBlock(), _createElementBlock("i", _hoisted_19))
              ], 8, _hoisted_17),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.t("common.export")), 1)
                ]),
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", {
                    class: "menu-link px-3",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fileExport && _ctx.fileExport(...args))),
                    style: {"font-size":"normal"}
                  }, [
                    (_ctx.disabledExport && !_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("warehouseInventory.inventoryReport")), 1)
                  ])
                ])
              ])
            ])), [
              [_directive_auth, { auth: ['export'] }]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_MBDatatablePlus, {
          loading: _ctx.loading,
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          "current-page": _ctx.currentPage,
          total: _ctx.total,
          "rows-per-page": _ctx.pageSize,
          showExpandBtn: false,
          order: "desc",
          onCurrentChange: _ctx.onCurrentPageChange,
          onItemsPerPageChange: _ctx.onRowsPerPageChange,
          onSort: _ctx.onColumnSort
        }, {
          "cell-guid": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(item.identification_code), 1)
            ])
          ]),
          "cell-stocked_date": _withCtx(({ row: item }) => [
            (item.__show.inventory_date)
              ? (_openBlock(), _createBlock(_component_el_popover, {
                  key: 0,
                  placement: "top",
                  width: "auto",
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_ctx.getDiffDays(item.__show.inventory_date) >= 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_ctx.getDiffDays(item.__show.inventory_date) > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.t("common.inDays", [
                          _ctx.getDiffDays(item.__show.inventory_date),
                        ])), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.t("common.today")), 1))
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.t("common.agoDays", [
                        _ctx.getLateDays(item.__show.inventory_date),
                      ])), 1))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatDateTime(item.__show.inventory_date, "YYYY-MM-DD HH:mm")) + " ", 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "cell-article": _withCtx(({ row: item }) => [
            _createVNode(_component_product_info, {
              gallery: _ctx.commonGalleryImages(item.__show.images),
              name: item.__show.name,
              name_en: item.__show.name_en,
              source_link: item.__show.source_link,
              brand_id: item.__show.brand
            }, null, 8, ["gallery", "name", "name_en", "source_link", "brand_id"])
          ]),
          "cell-sku": _withCtx(({ row: item }) => [
            _createVNode(_component_sku_info, {
              brand_article_no: item.__show.brand_article_no,
              color: item.__show.color,
              size: item.__show.size,
              product_identifier_id: item.__show.product_identifier_id
            }, null, 8, ["brand_article_no", "color", "size", "product_identifier_id"])
          ]),
          "cell-warehouse": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(item.__show.warehouse_name), 1),
              _withDirectives(_createElementVNode("div", _hoisted_30, [
                (item.__show.shelf_id !== '' && item.__show.shelf_id !== 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.__show.shelf), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.t("warehouseInventory.default")), 1))
              ], 512), [
                [_vShow, _ctx.options.warehouseInventoryType === '2']
              ])
            ])
          ]),
          "cell-sku_inventory_type": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.__show.sku_inventory_type), 1)
          ]),
          "cell-stock_in_inventory_target": _withCtx(({ row: item }) => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(item.__show.stock_in_inventory_target), 1),
              _createElementVNode("div", _hoisted_33, _toDisplayString(item.sale_order_number), 1)
            ])
          ]),
          "cell-warehouse_inventory_status": _withCtx(({ row: item }) => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getWarehouseInventoryStatusMap(item.status))
            }, _toDisplayString(item.__show.warehouse_inventory_status), 3)
          ]),
          "cell-incoming_qty": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.incoming_qty), 1)
          ]),
          "cell-reserved_qty": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.reserved_qty), 1)
          ]),
          "cell-locked_qty": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.locked_qty), 1)
          ]),
          "cell-available_qty": _withCtx(({ row: item }) => [
            _createTextVNode(_toDisplayString(item.available_qty), 1)
          ]),
          "cell-actions": _withCtx(({ row: item }) => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [
              (item.status == _ctx.WarehouseInventoryStatus.Reserved)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modal_update_inventory",
                    onClick: ($event: any) => (_ctx.updateItem(item))
                  }, [
                    _createElementVNode("span", _hoisted_36, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                    ])
                  ], 8, _hoisted_35))
                : _createCommentVNode("", true)
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ]),
          _: 1
        }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange", "onSort"])
      ])
    ]),
    _createVNode(_component_update_inventory, {
      option: _ctx.options,
      itemData: _ctx.options.itemData,
      onResetForm: _ctx.resetItem,
      onUpdateList: _ctx.updateList
    }, null, 8, ["option", "itemData", "onResetForm", "onUpdateList"]),
    _createVNode(_component_add_stock_in, {
      option: _ctx.options,
      onUpdateList: _ctx.updateList
    }, null, 8, ["option", "onUpdateList"])
  ], 64))
}